module.exports = __webpack_public_path__ + "static/media/requests-active.a187c04d.svg";